import { render, staticRenderFns } from "./settings.vue?vue&type=template&id=3bc98da2"
import script from "./settings.vue?vue&type=script&lang=ts"
export * from "./settings.vue?vue&type=script&lang=ts"
import style0 from "./settings.vue?vue&type=style&index=0&id=3bc98da2&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bc98da2')) {
      api.createRecord('3bc98da2', component.options)
    } else {
      api.reload('3bc98da2', component.options)
    }
    module.hot.accept("./settings.vue?vue&type=template&id=3bc98da2", function () {
      api.rerender('3bc98da2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/settings.vue"
export default component.exports